<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>Additional Services Info.
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ eExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="contentBox">
        <h1>Additional Services Info.</h1>
        <p class="my-3">&nbsp;</p>
        <div class="left">
          <table width="100%" class="tableDisplay">
            <tr>
              <th width="30%" class="text-left">Service</th>
              <th width="30%" class="text-center">Paid</th>
              <th width="20%" class="text-center">Free</th>
              <th width="20%" class="text-center" nowrap>Show</th>
            </tr>
            <tr>
              <td nowrap>1. Company Profile</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center">
                <a :href="fancyboxImg1" data-fancybox="images"
                  ><img src="@/assets/images/view.png"
                /></a>
              </td>
            </tr>
            <tr>
              <td nowrap>2. Publish Products</td>
              <td align="center"><span name="Exh_ProductAmount_vip"></span></td>
              <td align="center"><span name="Exh_ProductAmount"></span></td>
              <td align="center">
                <a :href="fancyboxImg2" data-fancybox="images"
                  ><img src="@/assets/images/view.png"
                /></a>
              </td>
            </tr>
            <tr>
              <td nowrap>3. Booth Events</td>
              <td align="center">
                <span name="Exh_BoothEventAmount_vip"></span>
              </td>
              <td align="center"><span name="Exh_BoothEventAmount"></span></td>
              <td align="center">
                <a :href="fancyboxImg3" data-fancybox="images"
                  ><img src="@/assets/images/view.png"
                /></a>
              </td>
            </tr>

            <tr>
              <td nowrap>4. Publish News</td>
              <td align="center"><span name="Exh_NewsAmount_vip"></span></td>
              <td align="center"><span name="Exh_NewsAmount"></span></td>
              <td align="center">
                <a :href="fancyboxImg9" data-fancybox="images"
                  ><img src="@/assets/images/view.png"
                /></a>
              </td>
            </tr>
            <tr>
              <td nowrap>5. Publish News Videos</td>
              <td align="center"><span name="Exh_VideoAmount_vip"></span></td>
              <td align="center"><span name="Exh_VideoAmount"></span></td>
              <td align="center">
                <a :href="fancyboxImg4" data-fancybox="images"
                  ><img src="@/assets/images/view.png"
                /></a>
              </td>
            </tr>
            <tr>
              <td>6. View Inquiries</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center">
                <a :href="fancyboxImg5" data-fancybox="images"
                  ><img src="@/assets/images/view.png"
                /></a>
              </td>
            </tr>
            <tr>
              <td nowrap>7. Exclusive Floor Plan</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="red bold">x</span></td>
              <td align="center">
                <a :href="fancyboxImg6" data-fancybox="images"
                  ><img src="@/assets/images/view.png"
                /></a>
              </td>
            </tr>
            <tr>
              <td>8. Show Preview e-Newsletter</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="red bold">x</span></td>
              <td align="center">
                <a :href="fancyboxImg7" data-fancybox="images"
                  ><img src="@/assets/images/view.png"
                /></a>
              </td>
            </tr>
            <tr>
              <td>9. Search Priority</td>
              <td align="center"><span class="green bold">v</span></td>
              <td align="center"><span class="red bold">x</span></td>
              <td align="center">
                <a :href="fancyboxImg8" data-fancybox="images"
                  ><img src="@/assets/images/view.png"
                /></a>
              </td>
            </tr>

            <tr class="bold">
              <th class="text-left">Fee</th>
              <th class="text-center">NT$ 10,500 Tax included</th>
              <th class="text-center">Free</th>
              <th class="text-center">&nbsp;</th>
            </tr>
          </table>
          <p class="my-3">&nbsp;</p>
          <p class="italic">
            Length of Service：from today to 2 months after the expo
          </p>
        </div>
        <div class="right">
          <h3>Sales Info.</h3>
          <p class="my-3">&nbsp;</p>
          <div name="ExpoContact"></div>
        </div>
        <p class="clear"></p>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  metaInfo() {
    return {
      title: `Additional Services Info. - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      externalLink: "https://www.chanchao.com.tw/",

      UserId: "",
      RegNo: "",
      fancyboxImg1: require("@/assets/images/upgrade/en/02基本資訊.jpg"),
      fancyboxImg2: require("@/assets/images/upgrade/en/01產品發佈.jpg"),
      fancyboxImg3: require("@/assets/images/upgrade/04攤位活動.png"),
      fancyboxImg9: require("@/assets/images/upgrade/en/03新聞稿.jpg"),

      fancyboxImg5: require("@/assets/images/upgrade/en/04產品詢問函.jpg"),
      fancyboxImg6: require("@/assets/images/upgrade/en/05平面圖.jpg"),
      fancyboxImg7: require("@/assets/images/upgrade/en/06展前快訊.jpg"),
      fancyboxImg8: require("@/assets/images/upgrade/en/07關鍵字.jpg"),
      fancyboxImg4: require("@/assets/images/upgrade/en/08影音.jpg"),

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
    };
  },

  methods: {
    openInDefaultBrowser(url) {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // 检测是否在 Facebook 内置浏览器中
      if (userAgent.includes("FBAN") || userAgent.includes("FBAV")) {
        // Android
        if (/android/i.test(userAgent)) {
          const androidIntent = `intent://${url.replace(
            /^https?:\/\//,
            ""
          )}#Intent;scheme=https;package=com.android.chrome;end`;
          window.location.href = androidIntent;
        }
        // iOS
        else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          // const iosUrl = `googlechrome://${url.replace(/^https?:\/\//, '')}`
          // window.location.href = iosUrl

          const userAgent = window.navigator.userAgent;
          // 檢查 User Agent 是否包含 Safari 字符串
          const isSafari = !!userAgent.match(/Version\/[\d.]+.*Safari/);

          if (isSafari) {
            // 如果是 Safari，直接打開 URL
            window.location.href = url;
          } else {
            // 如果不是 Safari，使用 Google Chrome URL Scheme 打開
            const chromeUrl = `googlechrome://${url.replace(
              /^https?:\/\//,
              ""
            )}`;
            window.location.href = chromeUrl;
          }
        }
      } else {
        // 非 Facebook 内置浏览器，使用 window.open
        window.open(url, "_blank");
      }
    },
  },

  created() {
    const vm = this;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let nowPage = location.href;
    let RegNo = nowPage.split("no=")[1];

    let lang = "en";

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${RegNo}?lang=${lang}`
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });

    $.getJSON(
      "/apiExhibitors/AdvContact/" + RegNo,
      {
        lang: lang,
      },
      function (data) {
        $('[name="ExpoContact"]').html(data.Data.AdvContact);
      }
    );

    //方案數量
    $.getJSON(
      "/apiExhibitors/Exhibition/" + RegNo,
      { lang: lang },
      function (data) {
        // console.log(data)
        $('[name="Exh_ProductAmount"]').text(data.Data.Exh_ProductAmount);
        $('[name="Exh_ProductAmount_vip"]').text(
          data.Data.Exh_ProductAmount_vip
        );
        $('[name="Exh_NewsAmount"]').text(data.Data.Exh_NewsAmount);
        $('[name="Exh_NewsAmount_vip"]').text(data.Data.Exh_NewsAmount_vip);
        $('[name="Exh_BoothEventAmount"]').text(data.Data.Exh_BoothEventAmount);
        $('[name="Exh_BoothEventAmount_vip"]').text(
          data.Data.Exh_BoothEventAmount_vip
        );
        $('[name="Exh_VideoAmount"]').text(data.Data.Exh_VideoAmount);
        $('[name="Exh_VideoAmount_vip"]').text(data.Data.Exh_VideoAmount_vip);
      }
    );
  },
};
</script>

<style lang="scss">
@import "./../../assets/helper/table.css";
@import "./../../assets/helper/fancybox.css";
</style>
